export default __webpack_public_path__ + "static/media/Kasala Banner_2020-01.3aa2a06f.png";